import { Routes } from '@angular/router';
import { Login } from './features/login/login';
import { MainLayout } from './layouts/main-layout/main-layout';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { authGuard } from './core/guards/auth-guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { WebsiteOverviewComponent } from './features/website-overview/website-overview.component';
import { websiteResolver } from './core/resolvers/website-resolver';
import { TestPageComponent } from './features/practice-field/test-page/test-page.component';
import { UserProfileComponent } from './layouts/user-profile/user-profile.component';
import { AllSslCertificatesComponent } from './features/all-ssl-certificates/all-ssl-certificates.component';
import { RestoreDetailsComponent } from './features/restores/components/restore-details/restore-details.component';
import { websiteRestoreResolver } from './core/resolvers/website-restore-resolver';
import { EmailComponent } from './features/email/email.component';
import { GroupOverviewComponent } from './features/group-overview/group-overview.component';
import { groupResolver } from './core/resolvers/group-resolver';
import { UsageComponent } from './features/usage/usage.component';
import { GroupUsageComponent } from './features/usage/components/group-usage/group-usage.component';
import { groupUsageResolver } from './core/resolvers/group-usage-resolver';
import { AllDnsZonesComponent } from './features/dns-zones/all-dns-zones.component';
import { DatabasesComponent } from './features/databases/databases.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, title: 'Websites & Groups' },
      {
        path: 'overview/:id',
        component: WebsiteOverviewComponent,
        title: 'Website',
        resolve: {
          websiteData: websiteResolver,
        },
      },
      {
        path: 'group/:id',
        component: GroupOverviewComponent,
        resolve: {
          groupData: groupResolver,
        },
        title: 'Group',
      },
      { path: 'test', component: TestPageComponent, title: 'Test Page' },
      { path: 'user-profile', component: UserProfileComponent, title: 'My Profile' },
      { path: 'ssl', component: AllSslCertificatesComponent, title: 'SSL Certificates' },
      { path: 'dns-zones', component: AllDnsZonesComponent, title: 'DNS Zones' },
      { path: 'databases', component: DatabasesComponent, title: 'Databases' },
      {
        path: 'restores/:restoreId/website/:websiteId',
        component: RestoreDetailsComponent,
        title: 'Restore Details',
        resolve: {
          restoreData: websiteRestoreResolver,
        },
      },
      {
        path: 'email',
        component: EmailComponent,
        title: 'Email',
      },
      {
        path: 'usage',
        component: UsageComponent,
        title: 'Usage',
      },
      {
        path: 'usage/group/:id',
        component: GroupUsageComponent,
        title: 'Usage Details',
        resolve: {
          group: groupUsageResolver,
        },
      },
    ],
  },

  {
    path: '',
    component: AuthLayout,
    children: [{ path: 'login', component: Login }],
  },
];
